<div class="content-div">
  <div class="info-bar">
    <app-breadcrumbs [breadcrumbs]="BreadcrumbsLink"></app-breadcrumbs>
    <app-basic-button id="help-btn-user-groups" type="secondary" isIcon="true" size="medium" (click)="openHelp()">
      <i class="fal far fa-info-circle fs-16"></i>
    </app-basic-button>
  </div>
  <div class="top-bar">
    <span class="page-header">{{ 'realtime:usergroups_userGroupsHeader' | i18next }}</span>
    <div class="right">
      <app-filter-input id="filter-input-user-groups" [(model)]="filter" (modelChange)="applyFilterFromProperty()"
        [placeholder]="'realtime:shared_lang_tableFilterLabel' | i18next" [width]="'350px'"></app-filter-input>
    </div>
  </div>
  <div class="content">
    <mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>

    <!-- No-data template -->
    <ng-template #noData>
      <div class="no-items">
        {{ 'realtime:noResults' | i18next }}
      </div>
    </ng-template>

    <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z2 full-width-table">
      <!-- User Group Name Column -->
      <ng-container matColumnDef="userGroupName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header [matTooltip]="'realtime:shared_tooltip_sort' | i18next" matTooltipClass="tooltip-font-14">{{ 'ticker:usergroups_usergroup' | i18next }}</th>
        <td mat-cell *matCellDef="let element">
          <a [routerLink]="['/real-time/user-groups/get-group', encodeURIComponent(element.userGroupName)]">{{ element.userGroupName }}</a>
        </td>
        <td mat-footer-cell *matFooterCellDef class="footer-label">
          <a [routerLink]="['/real-time/user-groups/all-agents']"><b>{{ 'realtime:usergroups_allAgents' | i18next }}</b></a>
        </td>
      </ng-container>

      <!-- Available Column -->
      <ng-container matColumnDef="available">
        <th mat-header-cell *matHeaderCellDef mat-sort-header [matTooltip]="'realtime:shared_tooltip_sort' | i18next" matTooltipClass="tooltip-font-14">{{ 'ticker:usergroups_status_available' | i18next }}</th>
        <td mat-cell *matCellDef="let element" class="text-right">{{ element.available }}</td>
        <td mat-footer-cell *matFooterCellDef class="footer-cell text-right">{{ totals?.available || 0 }}</td>
      </ng-container>

      <!-- Connecting Column -->
      <ng-container matColumnDef="connecting">
        <th mat-header-cell *matHeaderCellDef mat-sort-header [matTooltip]="'realtime:shared_tooltip_sort' | i18next" matTooltipClass="tooltip-font-14">{{ 'ticker:usergroups_status_connnecting' | i18next }}</th>
        <td mat-cell *matCellDef="let element" class="text-right">{{ element.connecting }}</td>
        <td mat-footer-cell *matFooterCellDef class="footer-cell text-right">{{ totals?.connecting || 0 }}</td>
      </ng-container>

      <!-- Connected Column -->
      <ng-container matColumnDef="connected">
        <th mat-header-cell *matHeaderCellDef mat-sort-header [matTooltip]="'realtime:shared_tooltip_sort' | i18next" matTooltipClass="tooltip-font-14">{{ 'ticker:usergroups_status_connected' | i18next }}</th>
        <td mat-cell *matCellDef="let element" class="text-right">{{ element.connected }}</td>
        <td mat-footer-cell *matFooterCellDef class="footer-cell text-right">{{ totals?.connected || 0 }}</td>
      </ng-container>

      <!-- Busy Column -->
      <ng-container matColumnDef="busy">
        <th mat-header-cell *matHeaderCellDef mat-sort-header [matTooltip]="'realtime:shared_tooltip_sort' | i18next" matTooltipClass="tooltip-font-14">{{ 'ticker:usergroups_status_busy' | i18next }}</th>
        <td mat-cell *matCellDef="let element" class="text-right">{{ element.busy }}</td>
        <td mat-footer-cell *matFooterCellDef class="footer-cell text-right">{{ totals?.busy || 0 }}</td>
      </ng-container>

      <!-- Wrap Up Column -->
      <ng-container matColumnDef="wrapUp">
        <th mat-header-cell *matHeaderCellDef mat-sort-header [matTooltip]="'realtime:shared_tooltip_sort' | i18next" matTooltipClass="tooltip-font-14">{{ 'ticker:usergroups_status_wrapUp' | i18next }}</th>
        <td mat-cell *matCellDef="let element" class="text-right">{{ element.wrapUp }}</td>
        <td mat-footer-cell *matFooterCellDef class="footer-cell text-right">{{ totals?.wrapUp || 0 }}</td>
      </ng-container>

      <!-- No Answer Column -->
      <ng-container matColumnDef="noAnswer">
        <th mat-header-cell *matHeaderCellDef mat-sort-header [matTooltip]="'realtime:shared_tooltip_sort' | i18next" matTooltipClass="tooltip-font-14">{{ 'ticker:usergroups_status_noAnswer' | i18next }}</th>
        <td mat-cell *matCellDef="let element" class="text-right">{{ element.noAnswer }}</td>
        <td mat-footer-cell *matFooterCellDef class="footer-cell text-right">{{ totals?.noAnswer || 0 }}</td>
      </ng-container>

      <!-- Pause Column -->
      <ng-container matColumnDef="pause">
        <th mat-header-cell *matHeaderCellDef mat-sort-header [matTooltip]="'realtime:shared_tooltip_sort' | i18next" matTooltipClass="tooltip-font-14">{{ 'ticker:usergroups_status_pause' | i18next }}</th>
        <td mat-cell *matCellDef="let element" class="text-right">{{ element.pause }}</td>
        <td mat-footer-cell *matFooterCellDef class="footer-cell text-right">{{ totals?.pause || 0 }}</td>
      </ng-container>

      <!-- Logged Off Column -->
      <ng-container matColumnDef="loggedOff">
        <th mat-header-cell *matHeaderCellDef mat-sort-header [matTooltip]="'realtime:shared_tooltip_sort' | i18next" matTooltipClass="tooltip-font-14">{{ 'ticker:usergroups_status_loggedOff' | i18next }}</th>
        <td mat-cell *matCellDef="let element" class="text-right">{{ element.loggedOff }}</td>
        <td mat-footer-cell *matFooterCellDef class="footer-cell text-right">{{ totals?.loggedOff || 0 }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

      <!-- No data row -->
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" [attr.colspan]="displayedColumns.length">
          <ng-container *ngTemplateOutlet="noData"></ng-container>
        </td>
      </tr>

      <tr mat-footer-row *matFooterRowDef="displayedColumns" class="footer-row" [hidden]="dataSource.filteredData.length == 0"></tr>
    </table>
  </div>
</div>
